import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import CustomEase from 'gsap/CustomEase';
import is from '../../src/js/common/is';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

document.addEventListener( 'DOMContentLoaded', () => {
	'use strict'

	const section = document.querySelector('.hero-animation-holder');

	if (!section) return false;

	document.body.classList.add('hero-animation');

	const heroTop = section.querySelector('.hero-top');
	const hero = section.querySelector('.hero');
	const btn = section.querySelector('.btn-start');
	const circleBg = section.querySelector('.circle-bg');

	async function animationLoaded (animation) {
		if (animation.isLoaded) {
		  return true
		}
		
		return new Promise((resolve, reject) => {
		  animation.addEventListener('DOMLoaded', () => {
			resolve(true)
		  })
		})
	}

	const lottie_player_top = heroTop.querySelector('lottie-player')
	const lottie_top = lottie_player_top.getLottie();

	const lottie_player_hero = hero.querySelector('lottie-player')
	const lottie_hero = lottie_player_hero.getLottie();

	lottie_top.stop();
	lottie_hero.stop();

	const heroBody = hero.querySelector('.hero-body');
	let mm = gsap.matchMedia();

	let animation_destroyed = false;
	let animation_inited = false;

	const height = document.documentElement.clientHeight * (is.mobile() ? 8 : 4)

	gsap.set(heroTop, {
		position: 'absolute',
	});
	gsap.set(hero, {
		autoAlpha: 0,
	});

	// force scroll top
	const html = document.querySelector('html')
	let scrollBehaviorSmooth = false;
	if (getComputedStyle(html).scrollBehavior == 'smooth') {
		scrollBehaviorSmooth = true;
		html.style.setProperty('scroll-behavior', 'auto')
	}
	document.scrollingElement.scrollTo({ behavior: "instant", top: 0})
	setTimeout(function() {
		document.scrollingElement.scrollTo({ behavior: "instant", top: 0})
		if (scrollBehaviorSmooth) {
			html.style.setProperty('scroll-behavior', 'smooth')
		}
	}, 150)

	const destroy = () => {
		if (animation_destroyed) return false;

		animation_destroyed = true;
	
		setTimeout(()=> {
			if (tl && tl.scrollTrigger) {
				tl.scrollTrigger.disable();
				tl.kill()
	
				if (section.parentElement.classList.contains('.pin-spacer')) {
					gsap.set(section.parentElement, {clearProps: true})
				}
				gsap.set(section, {clearProps: true})
	
				gsap.set(heroTop, {display: 'none'});
				gsap.set(hero, {autoAlpha: 1});
				gsap.set(heroBody, {autoAlpha: 1});

				gsap.set(lottie_player_hero, {
					transform: 'scale(1)'
				})

				gsap.set('html', {
					'scroll-behavior': 'auto'
				})
				document.scrollingElement.scrollTo({ behavior: "instant", top: 1})
				gsap.set('html', {
					'scroll-behavior': 'smooth'
				})

				lottie_hero.loop = true
				lottie_hero.play();

				document.body.classList.remove('hero-animation');

				resize();

				document.dispatchEvent(new CustomEvent("hero-destroy", {bubbles: true}));
			}
		}, 1);
	}

	const resize = () => {
		setTimeout(()=>{
			window.dispatchEvent(new Event('resize'));
		}, 10)
	}

	const getCirleSize = () => {
		const diagonalSize =  Math.sqrt(Math.pow(window.innerHeight, 2) + Math.pow(window.innerWidth, 2));
		const height = gsap.getProperty(".circle-bg", "height");
		return (diagonalSize / height );
	}

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: section,
			start: () => {
				return "top "+ gsap.getProperty(".header", "height") + 'px';
			},
			end: () => {
				return "+=" + height + 'px';
			},
			scrub: 1,
			pin: true,
			markers: false,
		},
		once: true,
		onComplete: () => {
			if (tl.progress() == 1) {
				destroy();
			}
		},
		onUpdate: () => {
			if (tl.progress() >= 0.95) {
				destroy();
			}
		}
	});
	
	const desktop_animation = () => {
		if (animation_destroyed) return false;

		tl.fromTo('.section-right', {
			translateX: '0%',
			'--translate': '0%',
			'--padding': '50%',
		}, {
			translateX: '-50%',
			'--translate': '0.25%',
			'--padding': '0%',
		}, 0);
	
		tl.fromTo(circleBg, {
			scale: 1,
		}, {
			ease:  "power1.in",
			scale: ()=>{
				return getCirleSize();
			},
		}, 0.1);

		tl.to(lottie_player_top, {
			onUpdate: function() {
				const tween = this;
				var progress = tween.duration() > 0 ? tween.progress() : 0;
				lottie_top.goToAndStop(Math.ceil( lottie_top.getDuration() * 1000 * progress ));
			},
			duration: 1.5,
		}, '<');
	
		tl.fromTo(btn, {
			autoAlpha: 1,
		}, {
			autoAlpha: 0,
			duration: 0.15,
		}, '<');
	
		tl.fromTo(heroTop, {
			autoAlpha: 1,
		}, {
			autoAlpha: 0,
		}, '+=0.1')
	
		tl.fromTo(hero, {
			autoAlpha: 0,
		}, {
			autoAlpha: 1,
			onStart: () => {
				lottie_hero.stop();
			},
			onComplete: () => {
				lottie_hero.loop = true;
				lottie_hero.play();
			},
			duration: 1
		}, '-=0.4');
	}
	const mobile_animation = () => {

		if (animation_destroyed) return false;

		const aspect_ratio = lottie_hero.animationData.w / lottie_hero.animationData.h;
		gsap.set(lottie_player_hero, {
			height: 'auto',
		})
		gsap.set(lottie_player_hero, {
			'aspect-ratio': aspect_ratio,
			height: 'auto',
			transform: () =>{
				const scale = gsap.getProperty(lottie_player_hero.parentElement, "height") / gsap.getProperty(lottie_player_hero, "height");

				return 'scale(' + scale + ')';
			},
		});

		gsap.set(heroBody, {
			autoAlpha: 0
		});

		tl.fromTo('.section-right', {
			translateY: '0%',
			'--translate': '0%',
			'--padding': '50%',
		}, {
			translateY: () => {
				return '-' + gsap.getProperty('.section-left', "height") + 'px';
			},
			'--translate': '0.25%',
			'--padding': '0%',
		}, 0);

		tl.fromTo(btn, {
			autoAlpha: 1,
		}, {
			autoAlpha: 0,
			duration: 0.1,
		}, 0.1);

		tl.fromTo(".circle-bg", {
			scale: 1,
		}, {
			ease:  "power1.in",
			scale: ()=>{
				return getCirleSize();
			},
		// }, '+=0.1');
		}, 0.1);

		tl.to(lottie_player_top, {
			onUpdate: function() {
				const tween = this;

				var progress = tween.duration() > 0 ? tween.progress() : 0;
				lottie_top.goToAndStop(Math.ceil( lottie_top.getDuration() * 1000 * progress ));
			},
			duration: 1.5,
		}, 0.2);

		tl.fromTo(hero, {
			autoAlpha: 0
		},
		{
			autoAlpha: 1,
			onComplete: () => {
				tl.set(heroTop, {
					autoAlpha: 0
				});
			},
			duration: 1,
		});

		tl.to(lottie_player_hero, {
			ease:  "circ.inOut",
			translateX: () => {
				const scale = gsap.getProperty(lottie_player_hero.parentElement, "height") / gsap.getProperty(lottie_player_hero, "height");
				let width = 100 - (scale * 100) + '%';
				return width;
			},
			onUpdate: function() {
				const tween = this;
				var progress = tween.duration() > 0 ? tween.progress() : 0;
				lottie_hero.goToAndStop(Math.ceil( lottie_hero.getDuration() * 1000 * progress ));
			},
			onComplete: () => {
				lottie_hero.stop();
				lottie_hero.play();
			},
			duration: 3
		});

		tl.to(lottie_player_hero, {
			translateX: 0,
			transform: 'scale(1)',

			onComplete: () => {
				gsap.set(lottie_player_hero, {
					transform: 'scale(1)',
				})
			},
			duration: 2
		});
		
		tl.to(heroBody, {
			autoAlpha: 1,
			duration: 1
		// }, '<');
		}, '-=0.5');
	}

	const init_animation = () => {

		if (!lottie_top.isLoaded || !lottie_hero.isLoaded) return false;

		if (animation_inited) return false;
		
		animation_inited = true

		mm.add("(min-width: 1024px)", () => {
			desktop_animation()
		});
	
		mm.add("(max-width: 1023px)", () => {
			mobile_animation();
		});
	}

	// Init
	animationLoaded(lottie_top).then(() => {
		init_animation();
	})

	animationLoaded(lottie_hero).then(() => {
		init_animation();
	})

	section.querySelector('.btn-start a').addEventListener('click', (e) => {
		e.preventDefault();
		tl.scrollTrigger.animation.play();
	});
} )